<template>
    <div class="h-full" v-if="hackReset">
        <div :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource"></Control>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                hackReset: true,
                config: {
                    isDetailDisplay: false,
                },
                editDataSource: [],
                initialDataSource: []
            }
        },
        methods: {
            init: function (obj) {
                this.config = {
                    isDetailDisplay: false,
                };
                this.editDataSource = {};
                this.initialDataSource = {};
            },
            onChangeEditDataSource: function (dataSource) {
                this.editDataSource = dataSource;
                this.initialDataSource = this.Utils.extend([],dataSource);
            },
            syncDataSource(){
                this.initialDataSource = this.Utils.extend([],this.editDataSource);
            },
            checkSaveStatus() {
                this.config.isDetailDisplay = false;
            }
        },
        components: {
            "Control": resolve => { require(['./components/stocklock.vue'], resolve) },
        }
    }
</script>

<style>
</style>